import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-volume-icon",
  templateUrl: "./volume-icon.component.html",
  styleUrls: ["./volume-icon.component.scss"],
})
export class VolumeIconComponent implements OnInit {
  @Input()
  overrideStyle = {};

  @Input()
  disabled = false;
  constructor() {}

  ngOnInit(): void {}
}
